import { lazy } from "react";

// Pages
export const Login = lazy(() => import("../pages/Auth/Login/Login"));
export const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword/ForgotPasswordPage"));
export const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
export const Home = lazy(() => import("../pages/TestHome/Home"));
export const AddSchool = lazy(() => import("../pages/School/AddSchoolForm"));
export const AddSchoolPanel = lazy(() => import("../pages/School/AddSchoolPanel"));
export const GroupList = lazy(() => import("../pages/GroupList/GroupList"));
export const SchoolOnBoarding = lazy(() => import("../pages/SchoolOnboarding/SchoolOnboarding"));
export const SchoolSupport = lazy(() => import("../pages/SchoolSupport/SchoolSupport"));
export const SchoolLead = lazy(() => import("../pages/SchoolSupport/SchoolLead"));
